import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import Runtime from '@get-bridge/learn-legacy-shared/dist/core/Runtime';
import PerformSettingsPayload from '../schemas/PerformSettingsPayload';
import defaultPayload from '../shared/defaultPayload'

export default DataRequest({
  schema: PerformSettingsPayload,
  url: `//${Runtime.get('LEARN_SUITE_URL')}/api/talent/admin/settings`,

  parse(normalize, payload) {
    if (
      !payload
      || typeof payload !== 'object'
      || !payload['GOALS.TERMINOLOGY']
    ) {
      return defaultPayload
    }

    return {
      goalTerminology: payload['GOALS.TERMINOLOGY'],
    }
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/perform_settings/data_requests/getPerformSettings.js